/**
 * Admin Route Guard
 * Only allows access for platform owners (isPlatformOwner on user)
 */

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../lib/auth';

interface AdminRouteProps {
  children: ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, isAuthenticated } = useAuthStore();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isPlatformOwner) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-900">
        <div className="p-6 border-2 border-black dark:border-gray-700 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(55,65,81,1)]">
          <h1 className="text-xl font-bold text-black dark:text-white mb-2">Geen toegang</h1>
          <p className="text-gray-600 dark:text-gray-400">Je hebt geen platform admin rechten.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
